<template>
  <div
    class="row"
    id="asset-register">

    <div class="col-12">
      <card-table
        title="Assets"
        :headers="assetList.headers"
        :items="dataItems"
        :selected-item="selectedAsset"
        @item-selected="selectItem">
        <div slot="footer">
          <div class="float-lg-right">
            <div
              class="btn btn-primary border border-dark"
              @click="startAssetCreation()">
              <i class="fa fa-plus-circle" /> Add new asset
            </div>
          </div>
        </div>
      </card-table>
    </div>

    <div class="col-12">
      <asset-detail
        :asset="selectedAsset"
        :asset-types="assetTypes">
        <!-- see AjaxListMixin -->
        <status-feedback
          slot="feedback"
          :success-feedback="successFeedback"
          :fail-feedback="failFeedback"
          :errors="errors"
          :fade-timeout="5000" />
      </asset-detail>
    </div>

    <!-- Create asset form -->
    <modal-card
      v-if="modalOpen"
      @close="modalOpen = false">
      <h4
        class="card-title"
        slot="header">
        Create asset
      </h4>

      <div>
        <asset-form
          :editing="true"
          :asset="newAsset"
          :asset-types="assetTypes" />
      </div>

      <div
        slot="footer"
        class="float-lg-right">
        <status-feedback
          slot="feedback"
          :fail-feedback="failFeedback"
          :errors="errors"
          :fade-timeout="5000" />
        <div
          class="btn btn-primary border border-dark"
          @click="createAsset(newAsset)">
          <i class="fa fa-plus-circle" /> Create
        </div>
        <div
          class="btn btn-secondary border border-dark"
          @click="cancelAssetCreation()">
          <i class="fa fa-undo" /> Cancel
        </div>
      </div>
    </modal-card>
  </div>
</template>

<script>
import AjaxList from '../mixins/AjaxListMixin';
import Modal from '../common/ModalCard';
import AssetForm from './AssetFormComponent';
import Utils from '../mixins/ObjectUtilsMixin';

const defaultAssetFactory = () => {
    return {
        installation_date: null,
        name: null,
        notes: null,
        parent_asset_id: null,
        quantity: null,
        unit_price: null,
        asset_status_id: null,
        asset_type_id: null,
        asset_condition_id: null,
    };
};

export default {
    components: {
        'modal-card': Modal,
        'asset-form': AssetForm,
    },

    mixins: [
        AjaxList,
        Utils,
    ],

    props: {
        assetList: {
            type: Object,
            default: null,
        },
        assetTypes: {
            type: Object,
            default: () => {
                return {
                    'types': [],
                    'statuses': [],
                    'conditions': [],
                };
            },
        },
        schemeId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            selectedAsset: null,
            dataItems: this.assetList.items,
            url: `assets`,
            modalOpen: false,
            newAsset: null,
        };
    },

    mounted() {
        if (this.dataItems) {
            this.dataItems.forEach(item => {
                item.installation_date = new Date(item.installation_date);
            });
            this.selectedAsset = this.dataItems[0];
        }
    },

    methods: {
        selectItem(item) {
            this.selectedAsset = item;
        },
        getItemById(id) {
            let filtered = this.dataItems.filter(item => {
                return item.id && item.id === id;
            });

            return filtered.length > 0 ? filtered[0] : null;
        },

        updateAsset(asset, callback) {
            let assetData = this.objectOnly(
                asset,
                [
                    'id',
                    'name',
                    'installation_date',
                    'quantity',
                    'unit_price',
                    'notes',
                    'asset_type_id',
                    'asset_status_id',
                    'asset_condition_id',
                ]
            );

            this.onUpdate(assetData, callback);
        },

        deleteSelectedItem() {
            this.onDelete(this.selectedAsset, () => {
                this.selectedAsset = null;
            });
        },

        startAssetCreation() {
            this.newAsset = defaultAssetFactory();
            this.modalOpen = true;
        },

        cancelAssetCreation() {
            this.modalOpen = false;
            this.newAsset = null;
        },

        createAsset(newAsset) {
            this.onAdd(newAsset, 0, () => {
                this.updateAsset(newAsset, (newId, savedAsset) => {
                    this.modalOpen = false;
                    this.newAsset = null;
                    this.selectItem(savedAsset);
                });
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/asset-register/AssetRegisterComponent.vue